import script from "./TriadTooltip.vue?vue&type=script&setup=true&lang=js"
export * from "./TriadTooltip.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__